<template>
  <v-flex xs12>
    <v-card class="filter-selected my-0" color="#F8F8F8" outlined tile elevation="0">
      <template v-for="(item, index) in model">
        <v-chip
          close-icon="$close"
          close
          outlined
          label
          @input="$emit('clearItem', item)"
          color="#202020"
          :key="index"
          v-if="!item.hidden"
          class="mr-2 my-1"
        >
          <span class="body-2">{{ item }}</span>
        </v-chip>
      </template>
    </v-card>
  </v-flex>
</template>
<script>
  export default {
    name: "FilterSelected",
    props: {
      model: {
        type: Array,
        default: []
      }
    }
  }
</script>
